'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
  'use strict';

  angular.module('msUtility').directive('msKeypressGo', msKeypressGo);

  msKeypressGo.$inject = ['$state', '$document', '$log', '$timeout'];

  /**
   * @desc A directive that takes one parameter, the Keyboard Event key value that will trigger a $state change.
   * @param {String} msKeypressGo: Keyboard Event key value which, when pressed, will trigger a $stateChange
   * @example <a ui-sref="mainState.homepage({param1: 'state param value'})" ms-keypress-go="Home">
   */

  function msKeypressGo($state, $document, $log, $timeout) {
    var directive = {
      link: link,
      restrict: 'A'
    };
    return directive;

    function link(scope, element, attr) {
      var disabled = false;

      if (!attr.uiSref) {
        $log.warn('This directive must be used with uiSref.');
      }

      // arrow keys are only triggered by onkeyup/onkeydown, not onkeypress
      // user onkeyup to prevent users from holding down an arrow key to flip through everything too quickly.
      $document.bind("keyup", goToInspir);

      // Cleanup event listeners when this directive is destroyed.
      scope.$on('$destroy', function () {
        $document.unbind('keyup', goToInspir);
      });

      ///////////////////////

      function goToInspir(event) {
        if (!disabled && event.key === attr.msKeypressGo) {
          event.preventDefault();
          $state.go.apply($state, _toConsumableArray(Object.values(_srefAttrToState(attr.uiSref))));
          disabled = true;
          $timeout(function () {
            return disabled = false;
          }, attr.srefThrottle);
        }
      }

      // The uiSref attribute is a string that looks like this: 'stateName({stateParam1: value})'
      // The portion before the '(' is the state name,
      // the portion between '(' and ')' are the stateParams.
      function _srefAttrToState(sref) {
        return {
          toState: sref.substring(0, sref.indexOf('(')),
          stateParams: scope.$eval(sref.substring(sref.indexOf('(') + 1, sref.indexOf(')')))
        };
      }
    }
  }
})();